import React, { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import './LoginScreen.css';
import { ThemeToggle } from './ThemeToggle';

export const LoginScreen: React.FC = () => {
  const { signIn, notice } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event: React.FormEvent): Promise<void> => {
    event.preventDefault();
    if (submitting) return;

    setError(null);
    setSubmitting(true);
    try {
      await signIn(username, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not sign in');
      setPassword('');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-theme-toggle">
        <ThemeToggle />
      </div>
      <form className="login-card" onSubmit={handleSubmit}>
        <h1 className="login-title">Karting Live Timing</h1>
        <p className="login-subtitle">Sign in to view the timing feed</p>

        {notice && !error && <div className="login-notice">{notice}</div>}
        {error && (
          <div className="login-error" role="alert">
            {error}
          </div>
        )}

        <label className="login-label" htmlFor="login-username">
          Username
        </label>
        <input
          id="login-username"
          className="login-input"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          autoFocus
          required
        />

        <label className="login-label" htmlFor="login-password">
          Password
        </label>
        <input
          id="login-password"
          className="login-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />

        <button
          className="login-submit"
          type="submit"
          disabled={submitting || !username.trim() || !password}
        >
          {submitting ? 'Signing in…' : 'Sign in'}
        </button>

        <p className="login-footnote">
          Accounts are created by the site administrator.
        </p>
      </form>
    </div>
  );
};
